export default __webpack_public_path__ + "static/HelveticaNeueLTStd-Cn-753036847e6f777af67d956f824a4b31.otf";